import Vue from 'vue';
import firebase from 'firebase';
import 'firebase/auth';
import axios from 'axios';
import { sync } from 'vuex-router-sync';
import VueMoment from 'vue-moment';
import VueClipboard from 'vue-clipboard2';
import VueSmoothScroll from 'vue-smoothscroll';

import App from './App';

import router from './router';
import store from './store';

import './styles/main.scss';

import './components';

Vue.prototype.$http = axios;
Vue.use(VueMoment);
Vue.use(VueClipboard);
Vue.use(VueSmoothScroll);

sync(store, router);

if (process.env.NODE_ENV === 'development') {
  Vue.config.productionTip = false;
}

const config = {
  apiKey: 'AIzaSyBXMUivLCbSHRVGB09_XFAMUAQ-Rf3-9UM',
  authDomain: 'firstandfive-draft.firebaseapp.com',
  databaseURL: 'https://firstandfive-draft.firebaseio.com',
  projectId: 'firstandfive-draft',
  storageBucket: 'firstandfive-draft.appspot.com',
  messagingSenderId: '844473674625',
};

Vue.prototype.$firebase = firebase.initializeApp(config);

let app;

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    user.getIdToken().then((token) => {
      axios.defaults.headers.common.authorization = `Bearer ${token}`;
    });
  }

  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount('#app');
  }
});
